<template>
  <Accordion :initial-expanded="true" class="filter-card-container">
    <slot name="title">
      <h4 class="filter-card-title">{{ title }}</h4>
    </slot>
    <template #content>
      <div>
        <div class="filter-card-search-box">
          <slot name="search-box" />
        </div>
        <div class="filter-card-content">
          <slot />
        </div>
      </div>
    </template>
    <template #toggle-icon="slotProps">
      <Icons
        name="arrow"
        :rotate="90"
        :class="slotProps.toggledClass"
        class="filter-card-arrow"
      />
    </template>
  </Accordion>
</template>

<script>
import Accordion from '@sephora-asia/core-accordion/Accordion.vue'
import Icons from '@sephora-asia/atoms-icons/Icons.vue'

export default {
  name: 'FilterCard',
  components: {
    Accordion,
    Icons
  },
  props: {
    title: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="scss">
.filter-card-title {
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
</style>

<style lang="scss" scoped>
.filter-card-container {
  border-bottom: 1px solid $grey;
  padding: 10px 15px;
}

.filter-card-arrow {
  --icon-size: 18px;

  &.expand {
    transform: rotateZ(-90deg);
  }
}

.filter-card-content {
  max-height: 145px;
  overflow-y: auto;
  overflow-x: hidden;
}

.filter-card-search-box {
  margin-top: 10px;
  margin-bottom: 15px;
}

/deep/ .toggle-icon {
  right: 0;
}
</style>
